import React from 'react';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import styles from './index.module.less';

const ImageViewer: React.FC<React.HTMLAttributes<HTMLImageElement>> = (props) => {
  const ref = React.useRef<HTMLImageElement>(null);

  React.useEffect(
    () => {
      if (!ref.current) {
        return;
      }

      const viewer = new Viewer(ref.current, {
        title: false,
        toolbar: false,
        navbar: false,
      });

      // eslint-disable-next-line consistent-return
      return () => {
        viewer.destroy();
      };
    },
    [],
  );

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img ref={ref} className={styles.image} {...props} />;
};

export default ImageViewer;
